export const WorkspaceRoleMember = {
  definition: "WORKSPACE_MEMBER",
  name: {
    en: "Member",
    de: "Mitglied",
    fr: "Membre",
    tr: "Çalışma Alanı Üyesi",
  },
  description: {
    en: "Just Member",
    de: "Nur Mitglied",
    fr: "Juste membre",
    tr: "Sadece üye",
  },
};

export const WorkspaceRoleAccessor = {
  definition: "DEFAULT_ACCESSOR_TO_ORGANIZATIONS",
  name: {
    en: "Accessor",
    de: "Zugriffsrechte",
    fr: "Accesseur",
    tr: "Erişimci",
  },
  description: {
    en: "Member can access all organization in workspace as default",
    de: "Mitglied kann als Standard auf alle Organisationen im Arbeitsbereich zugreifen",
    fr: "Le membre peut accéder à toutes les organisations de l'espace de travail par défaut",
    tr: "Erşimci üye, çalışma alanındaki tüm organizasyonlara varsayılan olarak erişebilir",
  },
};

export const WorkspaceRoleAdmin = {
  definition: "WORKSPACE_ADMIN",
  name: {
    en: "Admin",
    de: "Administrator",
    fr: "Administrateur",
    tr: "Çalışma Alanı Yöneticisi",
  },
  description: {
    en: "All moves are allowed",
    de: "Alle Bewegungen sind erlaubt",
    fr: "Tous les mouvements sont autorisés",
    tr: "Tüm hareketlere izin verilir",
  },
};

export const workspaceRoles = [WorkspaceRoleAdmin, WorkspaceRoleAccessor, WorkspaceRoleMember];

export default {
  moduleName: "workspaceRole",

  namespaced: true,

  state: () => ({
    WorkspaceRoleMember,
    WorkspaceRoleAccessor,
    WorkspaceRoleAdmin,
    roles: workspaceRoles,
  }),
  getters: {
    roles: (state) => state.roles,
    WorkspaceRoleMember: (state) => state.WorkspaceRoleMember,
    WorkspaceRoleAccessor: (state) => state.WorkspaceRoleAccessor,
    workspaceRoles: (state) => state.workspaceRoles,
  },
};
